import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useState } from 'react';
import { arrayOf, bool, shape, string } from 'prop-types';
import { currencyFormatter } from '@magalu/stereo-ui-utils';
import { InstallmentTable, ProductFreight, NumberInstallment, TableHeading, TotalHeading, TotalBody, FeeHeading, FeeBody, InstallmentAmount, PlanTr, Discount, ShowMoreButton, InstallmentMethodText, LegalText } from './payment-methods.styles';
import { ProductPlusFreight, InstallmentNumberLabel, TotalLabel, InstallmentLabel, WithInterest, WithoutInterest, DiscountLabel } from './payment-methods.data';

const PaymentTable = _ref => {
  let {
    installments,
    showAll,
    showMoreLabel,
    luizaCard
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["installments", "showAll", "showMoreLabel", "luizaCard"]);

  const [allVisible, setAllVisible] = useState(showAll);

  const shouldHasInterest = plan => {
    return Boolean(Number((plan == null ? void 0 : plan.interestAmount) || 0));
  };

  const hasOneInterest = installments.some(plan => !!Number(plan.interestAmount));

  const renderInstallmentMethod = plan => {
    const hasInterest = shouldHasInterest(plan);
    const text = hasInterest ? WithInterest : WithoutInterest;
    const luizaCardFlag = !hasInterest ? luizaCard : false;
    const shouldRender = hasInterest && !luizaCard || !hasInterest && luizaCard !== null;
    return shouldRender ? /*#__PURE__*/React.createElement(InstallmentMethodText, {
      luizaCard: luizaCardFlag
    }, text) : null;
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InstallmentTable, _extends({
    allVisible: allVisible
  }, props), /*#__PURE__*/React.createElement(TableHeading, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(FeeHeading, null, /*#__PURE__*/React.createElement(ProductFreight, null, ProductPlusFreight), /*#__PURE__*/React.createElement(NumberInstallment, null, InstallmentNumberLabel)), /*#__PURE__*/React.createElement(TotalHeading, null, TotalLabel))), /*#__PURE__*/React.createElement("tbody", null, installments.map((plan, index) => {
    const hasInterest = shouldHasInterest(plan);
    return /*#__PURE__*/React.createElement(PlanTr, {
      index: index,
      key: plan == null ? void 0 : plan.installment
    }, /*#__PURE__*/React.createElement(FeeBody, null, /*#__PURE__*/React.createElement("span", null, Number(plan == null ? void 0 : plan.installment) > 1 && InstallmentLabel(plan == null ? void 0 : plan.installment), ' ', /*#__PURE__*/React.createElement(InstallmentAmount, null, currencyFormatter({
      value: plan == null ? void 0 : plan.installmentAmount
    }), hasInterest && luizaCard && '*')), Number(plan == null ? void 0 : plan.installment) === 1 && /*#__PURE__*/React.createElement(React.Fragment, null, !!Number((plan == null ? void 0 : plan.discount) || 0) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Discount, {
      as: "span"
    }, Number(plan == null ? void 0 : plan.discount), DiscountLabel))), renderInstallmentMethod(plan)), /*#__PURE__*/React.createElement(TotalBody, null, Number(plan == null ? void 0 : plan.installment) > 1 && currencyFormatter({
      value: plan == null ? void 0 : plan.totalAmount
    })));
  }))), hasOneInterest && luizaCard && /*#__PURE__*/React.createElement(LegalText, {
    "data-testid": "legal-text"
  }, "*Juros: Todos os encargos da opera\xE7\xE3o, como juros, custo de parcelamento e outras tarifas est\xE3o inclu\xEDdas neste valor."), (installments || []).length > 12 && !allVisible && /*#__PURE__*/React.createElement(ShowMoreButton, {
    "data-testid": "show-more",
    size: "small",
    onClick: () => setAllVisible(true)
  }, showMoreLabel));
};

PaymentTable.defaultProps = {
  installments: [],
  showAll: true,
  luizaCard: false,
  showMoreLabel: 'veja mais'
};
process.env.NODE_ENV !== "production" ? PaymentTable.propTypes = {
  installments: arrayOf(shape({})),
  showAll: bool,
  luizaCard: bool,
  showMoreLabel: string
} : void 0;
export default PaymentTable;